import { AppStore, SetSelectedNodesAction } from '@alfresco/aca-shared/store';
import { ShareDataTableAdapter, ShareDataRow } from '@alfresco/adf-content-services';
import { DataColumnComponent } from '@alfresco/adf-core';
import { ExtensionLoaderService, ExtensionService, RuleEvaluator } from '@alfresco/adf-extensions';
import { NodeEntry } from '@alfresco/js-api';
import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { AldenService } from 'projects/alden-extension/src/lib/services/alden.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  templateUrl: './custom-column-actions.component.html',
  styleUrls: ['./custom-column-actions.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class CustomActionsColumnComponent implements OnInit, OnDestroy {

  @Input() context: { data: ShareDataTableAdapter, row: ShareDataRow, col: DataColumnComponent};

  onDestroy$: Subject<boolean> = new Subject();
  isSmallScreen: boolean;
  actions: any[];
  loading: boolean;

  constructor(private breakpointObserver: BreakpointObserver,
    private cdRef: ChangeDetectorRef,
    protected extensionService: ExtensionService,
    private aldenService: AldenService,
    protected store: Store<AppStore>,
    protected loader: ExtensionLoaderService
  ) { 

  }

  async ngOnInit(): Promise<void> {
    this.loading = true;

    this.breakpointObserver.observe(['(max-width:1100px)']).pipe( takeUntil(this.onDestroy$) ).subscribe(match => {
      this.isSmallScreen = match.matches;
      this.cdRef.markForCheck();
    });

    this.actions = await this.aldenService.getContextActions(this.context);

    //Se filtran las acciones marcadas en el customData del Json para la columna de acciones (en el caso de que se asigne customData)
    if(this.customActions?.length > 0){
      this.actions = this.actions.filter(action =>
        this.customActions.some(customAction => action.id.startsWith(customAction))
      );
    }

    // Guardamos en el data, para los que tenemos como custom
    this.actions = this.actions.sort((a, b) => a.order - b.order);
    this.actions.forEach(a => { if(a.data) a.data.nodeEntry = this.nodeEntry; });

    this.loading = false;
    this.cdRef.detectChanges();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

  getEvaluator = (key: string): RuleEvaluator => {
    return this.extensionService.getEvaluator(key);
  };

  handleAction(actionRef: any) {
    const actionId = actionRef.actions?.click;
    if(actionId) {
      const selectionState = this.aldenService.getSelectionState(this.nodeEntry);
      const payload: any = selectionState.nodes;
      this.store.dispatch({ type: actionId, selection: selectionState, payload });
    }
  }

  prepareSelection() {
    this.store.dispatch(new SetSelectedNodesAction([this.nodeEntry]));
  }

  get nodeEntry() : NodeEntry {
    return this.context?.row?.node;
  }

  get customActions() : string[] {
    return this.context?.col.customData;
  }

  get maxActions() : number {
    return this.context?.col.format ? Number(this.context.col.format) : 5;
  }

  get showMenuAction() : boolean {
    return this.isSmallScreen || this.actions.filter((a) => a.type !== "separator").length > this.maxActions;
  }

}
